import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue'
interface Emits {
(e:'click'):void
}
interface Props {
  visible: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
(e:'click'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
}



watch(() => props.visible, (nVal) => {
  if (nVal) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed top-0 left-0 w-full h-screen bg-permaBlack z-20 bg-opacity-65",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('click')), ["stop"]))
  }))
}
}

})